module.exports = __webpack_public_path__ + "img/ttshop_dsh.1a038d7a.svg";